module.exports = {
  latestClaimsDate: new Date('2026-06-30'),

  // Historical trending data range on data.doctivityhealth.com (admin Trends
  // tab). Quarters are LexisNexis measurement quarters: each quarter's values
  // cover the trailing 12 months ending in that quarter.
  trendingStartQuarter: { year: 2022, quarter: 4 },
  trendingEndQuarter: { year: 2026, quarter: 2 },
};
